import {Film} from '@nlabs/gothamjs/icons';

import {featureScenes} from '../../content/featureScenes.js';

import type {ReactElement} from 'react';

const beats = ['Establish', 'Approach', 'Reveal'];
const captions = ['The harbor at dusk', 'The boat draws closer', 'Someone is waiting'];

export const StoryboardVisual = (): ReactElement => (
  <>
    <div className="mb-2 flex items-center justify-between text-[9px] tracking-[.14em] text-white/55"><span>THE RETURN / ONE SCENE</span><Film className="text-violet-300" size={13} /></div>
    <ol className="space-y-2">{featureScenes.storyboards!.map((scene, index) => (
      <li className="grid grid-cols-[100px_1fr] overflow-hidden rounded-lg border border-violet-300/15 bg-white/3" key={scene.stamp}>
        <img alt="" className="h-14 w-full object-cover" loading="lazy" src={scene.image} />
        <div className="flex min-w-0 flex-col justify-center px-3">
          <p className="text-[8px] font-medium tracking-[.08em] text-violet-300">0{index + 1} / {beats[index].toUpperCase()}</p>
          <p className="mt-1 text-[10px] leading-4 text-white/80">{captions[index]}</p>
        </div>
      </li>
    ))}</ol>
  </>
);
